import React from 'react';
import { PlusCircle, Send, FileDigit, Eye } from 'lucide-react';
import SidebarWidgetList from './SidebarWidgetList';

const AuthorSidebar = ({ 
  widgets, 
  visibleWidgets, 
  onToggleVisibility, 
  onAddWidgetClick, 
  onExportToAEM, 
  onExportToWord, 
  exportLoading 
}) => {
  return (
    <div className="fixed left-0 top-[56px] bottom-0 w-64 bg-white shadow-lg flex flex-col z-10">
      {/* Document Sections */}
      <div className="p-4 flex-1 overflow-auto">
        <div className="flex items-center justify-between mb-4">
          <h3 className="text-base font-semibold text-gray-800">Document Sections</h3>
        </div>

        <SidebarWidgetList 
          widgets={widgets} 
          visibleWidgets={visibleWidgets} 
          onToggleVisibility={onToggleVisibility} 
        />
      </div>

      {/* Action Buttons */}
      <div className="p-4 bg-gray-50 border-t border-gray-100">
        <h4 className="text-xs font-semibold text-gray-500 uppercase tracking-wider mb-3">Actions</h4>
        <div className="space-y-2">
          <button
            onClick={onAddWidgetClick}
            className="w-full py-2 px-3 bg-white border border-gray-200 hover:bg-gray-50 text-gray-700 rounded-lg text-sm font-medium transition-colors flex items-center gap-2.5 shadow-sm"
          >
            <PlusCircle size={16} className="text-primaryDark" />
            <span>Add New Section</span>
          </button>

          <button
            className={`w-full py-2 px-3 bg-white border border-gray-200 hover:bg-gray-50 text-gray-700 rounded-lg text-sm font-medium transition-colors flex items-center gap-2.5 shadow-sm ${exportLoading.aem ? 'opacity-70 cursor-not-allowed' : ''}`}
            onClick={onExportToAEM}
            disabled={exportLoading.aem}
          >
            <Send size={16} className="text-green-600" />
            {exportLoading.aem ? 'Exporting...' : 'Export to AEM'}
          </button>

          <button
            className={`w-full py-2 px-3 bg-white border border-gray-200 hover:bg-gray-50 text-gray-700 rounded-lg text-sm font-medium transition-colors flex items-center gap-2.5 shadow-sm ${exportLoading.word ? 'opacity-70 cursor-not-allowed' : ''}`}
            onClick={onExportToWord}
            disabled={exportLoading.word}
          >
            <FileDigit size={16} className="text-primaryDark" />
            {exportLoading.word ? 'Downloading...' : 'Download as Word'}
          </button>

          <button
            className="w-full py-2 px-3 bg-white border border-gray-200 hover:bg-gray-50 text-gray-700 rounded-lg text-sm font-medium transition-colors flex items-center gap-2.5 shadow-sm"
          >
            <Eye size={16} className="text-purple-600" />
            <span>Preview</span>
          </button>
        </div>
      </div>
    </div>
  );
};

export default AuthorSidebar;